import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const customId = "custom-id-yes";

const ReactNotificationComponent = ({ title, body }) => {
  if (title && body) {
    toast.info(<Display />, { toastId: customId });
    function Display() {
      return (
        <div>
          <p className="text-bold">{title}</p>
          <p>{body}</p>
        </div>
      );
    }
    return <ToastContainer />;
  } else {
    return null;
  }
};

export default ReactNotificationComponent;
